import {
  Holder,
  Pic,
  Overlay,
  Caption,
  Text,
  QuoteText,
  Pivot,
  PicHolder,
  TopQ,
  BottomQ,
  TitleHolder,
  Title,
  SubTitle
} from "./VisionariesSlide2.style"

import TopQIcon from "./top_quote.svg"
import BottomQIcon from "./bottom_quote.svg"

export default function VisionariesSlide2() {
  return (
    <Holder>
      <Pivot>
        <PicHolder>
          <Pic src="/assets/images/about/architects/1.jpg" />
          <TitleHolder>
            <Title>White Ink</Title>
            <SubTitle>Architects</SubTitle>
          </TitleHolder>
          <Overlay>
            <Caption>
              <TopQ src={TopQIcon} alt="" />
              <QuoteText>
                We start every project
                <br />
                by understanding how
                <br />
                people will use the
                <br />
                space, technology and
                <br />
                services in a practical,
                <br />
                everyday way.
              </QuoteText>
              <BottomQ src={BottomQIcon} alt="" />
              <Text>
                We call it Thinking from the Inside - not just the inside of buildings, but inside
                the minds and lives of the people who commission, build, work, live, pass through
                and enjoy them. Their needs and wellbeing influence everything we do.
              </Text>
              <Text>
                It gives us a focus as we work in collaboration with designers, contractors,
                developers and planners. We add clarity, logic and precision when and where it’s
                needed most.
              </Text>
              <Text>
                The result is a smoother and often more eﬃcient way to design and successfully
                deliver the project.
              </Text>
            </Caption>
          </Overlay>
        </PicHolder>
      </Pivot>
    </Holder>
  )
}
